'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Set SVG Icons as Background
 * @param {string} svg - path to svg-image or base-64
 * @param {string} [positionX='center'] - the x-alignement of image
 * @param {string} [positionY='center] - the y-alignement of image
 * @param {string} size - size of image
 */
var svgBackground = exports.svgBackground = function svgBackground(svg, size, positionX, positionY) {
  return '\n  background-image: url(\'' + svg + '\');\n  background-position: ' + (positionX || 'center') + ' ' + (positionY || 'center') + ';\n  background-size: ' + size + ';\n  background-repeat: no-repeat;\n';
};

/**
 * Set side radius to the component
 * @param {string} side - side of the component
 * @param {string} [radius=radiusConstants.default] - radius of side
 */
var sideRadius = exports.sideRadius = function sideRadius(side, radius) {
  return '\n  ' + ((side === 'left' || side === 'right') && '\n    border-bottom-' + side + '-radius: ' + radius + ';\n    border-top-' + side + '-radius: ' + radius + ';\n  ') + '\n  \n  ' + ((side === 'top' || side === 'bottom') && '\n    border-' + side + '-left-radius: ' + radius + ';\n    border-' + side + '-right-radius: ' + radius + ';\n  ') + '\n';
};

/**
 * Set transition
 * @param {string} property - transitioned propertied
 * @param {string} [speed='300ms'] - transition speed
 * @param {string} [ease='ease-out'] - transition easing function
 * @param {string} [delay='0ms'] - transition delay
 */
var transition = exports.transition = function transition(property, speed, ease, delay) {
  return '\n  transition-property: ' + property + ';\n  transition-duration: ' + (speed || '300ms') + ';\n  transition-timing-function: ' + (ease || 'ease-out') + ';\n  transition-delay: ' + (delay || '0ms') + ';\n';
};

/**
 * Visibility
 */
var elementInvisible = exports.elementInvisible = '\n  position: fixed;\n  opacity: 0;\n  pointer-events: none;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  height: 0;\n';

var elementInvisibleOff = exports.elementInvisibleOff = '\n  position: static;\n  opacity: initial;\n  pointer-events: initial;\n';

/**
 * Box shadow
 */
var boxShadow = exports.boxShadow = function boxShadow() {
  var elevation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(0, 0, 0, 0.1)';

  var blur1 = 2;
  var offset1 = 0;
  var x1 = 0;
  var y1 = blur1 / 2;

  var blur2 = (blur1 + 1) * Math.abs(elevation);
  var offset2 = (offset1 + 0.25) * Math.abs(elevation);
  var x2 = 0;
  var y2 = (y1 + 0.5) * elevation;

  var blur3 = blur2 + 1;
  var offset3 = offset2 + 0.25;
  var x3 = 0;
  var y3 = y2 + 0.5;

  var shadow1 = x1 + 'px ' + y1 + 'px ' + blur1 + 'px ' + offset1 + 'px ' + color;
  var shadow2 = x2 + 'px ' + y2 + 'px ' + blur2 + 'px ' + offset2 + 'px ' + color;
  var shadow3 = x3 + 'px ' + y3 + 'px ' + blur3 + 'px ' + offset3 + 'px ' + color;

  return 'box-shadow: ' + shadow1 + ', ' + shadow2 + ', ' + shadow3 + ';';
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/mixins/mixinsStyle.js
// module id = 630
// module chunks = 0